import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics'
import { EventProps, UserProfile, ITrackingProvider, TrackingInitOptions } from '../../../interfaces/event-tracker'

export class FirebaseNativeProvider implements ITrackingProvider {
  init (options?: TrackingInitOptions): void {
    if (options?.appVersion != null) {
      FirebaseAnalytics.setUserProperty({ name: 'app_version', value: options.appVersion }).catch(() => {})
    }
  }

  trackEvent ({ key, metadata }: EventProps): void {
    FirebaseAnalytics.logEvent({ name: key, params: metadata ?? {} }).catch(() => {})
  }

  setUser (user: UserProfile): void {
    FirebaseAnalytics.setUserId({ userId: user.uid }).catch(() => {})
    FirebaseAnalytics.setUserProperty({ name: 'login_id', value: user.aid }).catch(() => {})
    FirebaseAnalytics.setUserProperty({ name: 'email', value: user.email }).catch(() => {})
    FirebaseAnalytics.setUserProperty({ name: 'plan', value: user.tipo_usuario }).catch(() => {})
    FirebaseAnalytics.setUserProperty({ name: 'language', value: user.locale }).catch(() => {})
    FirebaseAnalytics.setUserProperty({ name: 'workspace_id', value: user.escritorio_seleccionado }).catch(() => {})
    if (user.escritorio_seleccionado && user.escritorios[user.escritorio_seleccionado]) {
      FirebaseAnalytics.setUserProperty({ name: 'workspace_name', value: user.escritorios[user.escritorio_seleccionado].nombre }).catch(() => {})
    }
  }
}
